import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { initializeErrorHandlers } from './lib/errorHandler.ts'

// Initialize global error handlers
initializeErrorHandlers();

import { HelmetProvider } from 'react-helmet-async'

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <HelmetProvider>
            <ErrorBoundary componentName="App">
                <App />
            </ErrorBoundary>
        </HelmetProvider>
    </StrictMode>,
)
